import React, { Component } from 'react'
import { Product as ProductPb } from '../../rpc/admin/products_pb';
import Input from '../forms/input';

interface TextAttributeProps {
    label: string;
    value: ProductPb.Variant.AttributeValuePair;
    disabled?: boolean;
    onChange?: (value: ProductPb.Variant.AttributeValuePair) => void;
}

interface TextAttributeState {}

class TextAttribute extends Component<TextAttributeProps, TextAttributeState> {

    private handleInputChange = (value: string) => {
        if (this.props.onChange) {
            const avp = this.props.value.clone();
            avp.setValue(value);
            this.props.onChange(avp)
        }
    }

    render() {
        return (
            <Input label={this.props.label}
                value={this.props.value.getValue()}
                disabled={this.props.disabled}
                onChange={this.handleInputChange} />
        );
    }
}

export default TextAttribute;
